import { render } from "./NewImport.vue?vue&type=template&id=38a01d00"
import script from "./NewImport.vue?vue&type=script&lang=js"
export * from "./NewImport.vue?vue&type=script&lang=js"

import "./NewImport.vue?vue&type=style&index=0&id=38a01d00&lang=css"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__